export const PAYMENT_MODE = "PAYMENT_MODE";
export const PAYMENT_MODE_SUCCESS = "PAYMENT_MODE_SUCCESS";
export const PAYMENT_MODE_ERROR = "PAYMENT_MODE_ERROR";
export const PAYMENT_MODE_CLEAR_DATA = "PAYMENT_MODE_CLEAR_DATA";
export const POST_PAYMENT_MODE = "POST_PAYMENT_MODE";
export const POST_PAYMENT_MODE_SUCCESS = "POST_PAYMENT_MODE_SUCCESS";
export const POST_PAYMENT_MODE_ERROR = "POST_PAYMENT_MODE_ERROR";
export const POST_PAYMENT_MODE_CLEAR_DATA = "POST_PAYMENT_MODE_CLEAR_DATA";
